module.exports = __webpack_public_path__ + "img/costEffective.68226d36.jpg";